import { Platform, StyleSheet } from 'react-native';
import theme from '../../../common/theme';
import { themeType } from '../../../common/theme-colors';

const isMobile = Platform.OS === 'ios' || Platform.OS === 'android';

export const makeStyles = (colors: themeType) =>
  StyleSheet.create({
    container: {
      ...(isMobile
        ? { maxWidth: '95%', height: 550 }
        : { maxWidth: 850, maxHeight: 700 }),
      alignSelf: 'center',
      alignItems: 'center',
      borderRadius: theme.radius.large,
      backgroundColor: colors.popupBg,
      ...theme.shadow.strong,
      overflow: 'hidden',
    },
    header: {
      paddingTop: 40,
      paddingBottom: 30,
      paddingHorizontal: 42,
      borderBottomWidth: 1,
      borderBottomColor: colors.borderColor,
    },
    title: {
      textAlign: 'center',
      fontSize: 20,
      lineHeight: 24,
      fontFamily: theme.fonts.medium,
      color: colors.text,
    },
    content: {
      flex: 1,
      paddingVertical: 10,
      paddingHorizontal: 20,
    },
    grid: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      columnGap: 16,
      marginBottom: 20,
    },
  });
